import { useEffect, useRef, useState } from 'react';
import { IonButton, IonButtons, IonContent, IonHeader, IonModal, IonSearchbar, IonTitle, IonToolbar } from '@ionic/react';
import { collettivaDietLabel, collettivaDietsByGroup } from '@trackeat/shared';

// T-441/T-438 — UI CONDIVISA dell'ordine per LETTO. UNA sola implementazione,
// usata sia dall'app del preposto (PrepostoBedsPage, con login) sia dalla pagina
// pubblica del QR (RepartoPublicPage, senza login). Così una modifica al form
// vale per entrambi e non possono più divergere.

export interface BedRowUI {
  key: string;
  letto: string;
  dietCode: string;
  note: string;
}

const DIET_GROUPS = collettivaDietsByGroup();
const normDiet = (s: string): string =>
  s.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim();

// CSS condivisa (inclusa una volta per pagina via <style>{BEDS_CSS}</style>).
export const BEDS_CSS = `
.bd-card{background:var(--ion-card-background,#fff);border:1px solid #e5edef;border-radius:14px;padding:10px 12px;margin:0 0 10px;box-shadow:0 1px 6px rgba(0,0,0,.05)}
.bd-card .top{display:flex;align-items:center;gap:10px;margin-bottom:8px}
.bd-letto{width:70px}
.bd-letto label,.bd-diet label,.bd-note label{display:block;font-size:11px;font-weight:700;color:#64748b;margin:0 0 3px 2px;text-transform:uppercase;letter-spacing:.03em}
.bd-letto input{width:100%;box-sizing:border-box;border:1px solid #d3dde0;border-radius:9px;padding:9px 8px;font-size:16px;font-weight:700;text-align:center;background:var(--ion-background-color,#fff);color:inherit}
.bd-diet{flex:1;min-width:120px}
.bd-diet-btn{width:100%;box-sizing:border-box;display:flex;align-items:center;justify-content:space-between;gap:8px;border:1px solid #d3dde0;border-radius:9px;padding:10px 10px;font-size:14px;font-weight:600;background:var(--ion-background-color,#fff);color:inherit;cursor:pointer;text-align:left}
.bd-diet-btn{transition:border-color .2s,background .2s,color .2s}
.bd-diet-btn.empty{border-color:#e0a94f;background:#fffaf0;color:#9a6212;font-weight:600;animation:bd-pulse-amber 1.5s ease-in-out infinite}
.bd-diet-btn.filled{border-color:#10b981;background:#ecfdf5;color:#065f46;font-weight:700;box-shadow:inset 3px 0 0 0 #10b981}
.bd-diet-btn.just{animation:bd-pop-green .8s cubic-bezier(.2,.85,.3,1.2)}
.bd-diet-btn:disabled{opacity:.6}
.bd-diet-btn .chev{color:#94a3b8;font-size:12px;flex:0 0 auto}
/* Spunta "dieta inserita" (come nelle ricette: campo compilato = verde). */
.bd-chk{display:inline-flex;align-items:center;justify-content:center;width:20px;height:20px;border-radius:50%;background:#10b981;color:#fff;font-size:12px;font-weight:900;flex:0 0 auto}
.bd-chk.pop{animation:bd-check-pop .6s ease-out both}
@keyframes bd-pulse-amber{0%,100%{box-shadow:inset 0 0 0 1.5px #f0b452}50%{box-shadow:inset 0 0 0 2px #f59e0b,0 0 0 3px rgba(245,158,11,.16)}}
@keyframes bd-pop-green{0%{transform:scale(.98)}42%{transform:scale(1.05);background:#c9f5e2;box-shadow:0 0 0 8px rgba(16,185,129,.16)}100%{transform:scale(1);box-shadow:0 0 0 0 rgba(16,185,129,0)}}
@keyframes bd-check-pop{0%{opacity:0;transform:scale(.2)}60%{opacity:1;transform:scale(1.25)}100%{opacity:1;transform:scale(1)}}
/* Con "riduci movimento" attivo: niente pop/scala (che è MOVIMENTO), ma teniamo un
   flash di COLORE verde → la conferma della dieta si nota comunque a colpo d'occhio. */
@media (prefers-reduced-motion:reduce){
  .bd-diet-btn.empty{animation:none;box-shadow:inset 0 0 0 2px #f59e0b}
  .bd-diet-btn.just{animation:bd-flash-green .7s ease-out}
  .bd-chk.pop{animation:none}
}
@keyframes bd-flash-green{0%{background:#b6efd6}100%{background:#ecfdf5}}
.bd-note input{width:100%;box-sizing:border-box;border:1px solid #d3dde0;border-radius:9px;padding:8px;font-size:13px;background:var(--ion-background-color,#fff);color:inherit}
.bd-del{background:none;border:none;color:#c0564f;font-size:18px;padding:4px 6px;cursor:pointer}
.bd-pick-group{font-size:11px;font-weight:800;letter-spacing:.05em;text-transform:uppercase;color:#0b6b63;padding:14px 4px 4px}
.bd-pick-item{display:flex;align-items:center;justify-content:space-between;width:100%;text-align:left;background:var(--ion-card-background,#fff);border:1px solid #e5edef;border-radius:11px;padding:13px 14px;margin:0 0 7px;font-size:15px;font-weight:600;color:#243b40;cursor:pointer}
.bd-pick-item.on{border-color:#12a594;background:#e8f7f4;color:#0b6b63}
.bd-pick-item .tick{color:#12a594;font-weight:800}
/* Conferma DENTRO la tendina: la dieta toccata lampeggia verde "✓ Inserito", le altre
   si attenuano un attimo → si nota subito cosa è stato inserito, poi avanza al letto dopo. */
.bd-pick-item.picked{border-color:#10b981;background:#c9f5e2;color:#065f46;animation:bd-item-pop .5s ease-out}
.bd-pick-item .inserted{color:#065f46;font-weight:900;font-size:14px;flex:0 0 auto}
.bd-pick-item[disabled]:not(.picked){opacity:.5}
@keyframes bd-item-pop{0%{transform:scale(.99);box-shadow:0 0 0 0 rgba(16,185,129,.5)}45%{transform:scale(1.02);box-shadow:0 0 0 6px rgba(16,185,129,.2)}100%{transform:scale(1);box-shadow:0 0 0 0 rgba(16,185,129,0)}}
@media (prefers-reduced-motion:reduce){.bd-pick-item.picked{animation:bd-item-flash .6s ease-out}}
@keyframes bd-item-flash{0%{background:#a3efce}100%{background:#c9f5e2}}
/* Letto ATTUALMENTE in inserimento: evidenziato per non perdere il filo durante l'inserimento rapido. */
.bd-card.active{border-color:#12a594;box-shadow:0 0 0 3px rgba(18,165,148,.28);background:var(--ion-card-background,#f2fbf9)}
.bd-active-tag{display:inline-block;font-size:11px;font-weight:800;letter-spacing:.03em;text-transform:uppercase;color:#fff;background:#12a594;border-radius:999px;padding:3px 11px;margin:0 0 8px}
.bd-card.active .bd-letto input{border-color:#12a594;background:#e8f7f4;color:#0b6b63}
/* Barra FISSA nel picker: quale LETTO si sta compilando. In un IonToolbar (non
   scorre col contenuto) → sempre visibile, anche da smartphone. */
.bd-pick-letto{background:#0b6b63;color:#fff;padding:9px 13px;font-size:15px;text-align:center;font-weight:600}
.bd-pick-letto b{font-size:18px;font-weight:800}
`;

interface BedCardProps {
  bed: BedRowUI;
  readOnly?: boolean;
  active?: boolean; // letto attualmente in inserimento → evidenziato
  onPatch: (patch: Partial<BedRowUI>) => void;
  onRemove: () => void;
  onOpenPicker: () => void;
}
/** Una card letto: Letto · Dieta (bottone → picker) · Note. */
export function BedCard({ bed, readOnly, active, onPatch, onRemove, onOpenPicker }: BedCardProps): JSX.Element {
  // Animazione "dieta inserita": quando la dieta passa da vuota a scelta, il bottone
  // fa un pop verde con la spunta (~0,8s), a colpo d'occhio. Come nelle ricette.
  const [flash, setFlash] = useState(false);
  const prevDiet = useRef(bed.dietCode);
  useEffect(() => {
    const was = prevDiet.current;
    prevDiet.current = bed.dietCode;
    if (!was && bed.dietCode) {
      setFlash(true);
      const t = setTimeout(() => setFlash(false), 850);
      return () => clearTimeout(t);
    }
    return undefined;
  }, [bed.dietCode]);
  const dietClass = bed.dietCode ? `filled${flash ? ' just' : ''}` : 'empty';
  return (
    <div className={`bd-card${active ? ' active' : ''}`}>
      {active && <div className="bd-active-tag">Letto {bed.letto || '—'} · in inserimento</div>}
      <div className="top">
        <div className="bd-letto">
          <label htmlFor={`letto-${bed.key}`}>Letto</label>
          <input
            id={`letto-${bed.key}`}
            inputMode="numeric"
            value={bed.letto}
            disabled={readOnly}
            onChange={(e) => onPatch({ letto: e.target.value })}
          />
        </div>
        <div className="bd-diet">
          <label>Dieta</label>
          <button type="button" className={`bd-diet-btn ${dietClass}`} disabled={readOnly} onClick={onOpenPicker}>
            <span>{bed.dietCode ? collettivaDietLabel(bed.dietCode) : '— scegli la dieta —'}</span>
            {bed.dietCode
              ? <span className={`bd-chk${flash ? ' pop' : ''}`}>✓</span>
              : <span className="chev">▾</span>}
          </button>
        </div>
        {!readOnly && (
          <button type="button" className="bd-del" aria-label="rimuovi letto" onClick={onRemove}>✕</button>
        )}
      </div>
      <div className="bd-note">
        <label htmlFor={`note-${bed.key}`}>Note (allergie / specifiche)</label>
        <input
          id={`note-${bed.key}`}
          value={bed.note}
          disabled={readOnly}
          placeholder="es. allergia frutta a guscio · carne frullata"
          onChange={(e) => onPatch({ note: e.target.value })}
        />
      </div>
    </div>
  );
}

interface DietPickerModalProps {
  open: boolean;
  currentCode: string;
  letto?: string; // numero del letto per cui si sta scegliendo la dieta (per non perdere il filo)
  onSelect: (code: string) => void;
  onClose: () => void;
}
/** Picker dieta in stile app (modale + ricerca + gruppi). */
export function DietPickerModal({ open, currentCode, letto, onSelect, onClose }: DietPickerModalProps): JSX.Element {
  const [search, setSearch] = useState('');
  // Dieta appena toccata: lampeggia verde "✓ Inserito" DENTRO la tendina per ~0,8s,
  // poi conferma (onSelect → avanza al letto dopo). Così la conferma si vede a colpo
  // d'occhio nel menu a tendina, non nascosta dietro di esso durante l'avanzamento.
  const [picked, setPicked] = useState<string | null>(null);
  const pickTimer = useRef<number | null>(null);
  const q = normDiet(search);
  const lettoTxt = (letto ?? '').trim();
  const confirmPick = (code: string): void => {
    if (picked) return; // conferma già in corso
    setPicked(code);
    setSearch('');
    pickTimer.current = window.setTimeout(() => { pickTimer.current = null; setPicked(null); onSelect(code); }, 800);
  };
  const handleClose = (): void => {
    if (pickTimer.current) { window.clearTimeout(pickTimer.current); pickTimer.current = null; }
    setPicked(null);
    onClose();
  };
  return (
    <IonModal isOpen={open} onDidDismiss={handleClose} onWillPresent={() => { setSearch(''); setPicked(null); }} initialBreakpoint={0.9} breakpoints={[0, 0.9, 1]}>
      <IonHeader>
        <IonToolbar>
          <IonTitle>Scegli la dieta</IonTitle>
          <IonButtons slot="end">
            <IonButton onClick={handleClose}>Chiudi</IonButton>
          </IonButtons>
        </IonToolbar>
        {/* Barra FISSA (nell'header, non scorre): quale letto si sta compilando. */}
        {lettoTxt && (
          <IonToolbar>
            <div className="bd-pick-letto">🛏️ Dieta per il <b>Letto {lettoTxt}</b></div>
          </IonToolbar>
        )}
      </IonHeader>
      <IonContent className="ion-padding">
        <IonSearchbar value={search} onIonInput={(e) => setSearch(String(e.detail.value ?? ''))} placeholder="Cerca dieta (es. diabetica…)" debounce={0} />
        {DIET_GROUPS.map((g) => {
          const items = g.diets.filter((d) => !q || normDiet([d.label, d.code, ...(d.aliases ?? [])].join(' ')).includes(q));
          if (items.length === 0) return null;
          return (
            <div key={g.group}>
              <div className="bd-pick-group">{g.label}</div>
              {items.map((d) => {
                const isPicked = picked === d.code;
                return (
                  <button
                    key={d.code}
                    type="button"
                    className={`bd-pick-item${currentCode === d.code ? ' on' : ''}${isPicked ? ' picked' : ''}`}
                    disabled={picked !== null}
                    onClick={() => confirmPick(d.code)}
                  >
                    <span>{d.label}</span>
                    {isPicked
                      ? <span className="inserted">✓ Inserito</span>
                      : (currentCode === d.code && <span className="tick">✓</span>)}
                  </button>
                );
              })}
            </div>
          );
        })}
        <div style={{ height: 24 }} />
      </IonContent>
    </IonModal>
  );
}
